import React from 'react';
import { ResponsiveBar } from '@nivo/bar';

/*
  # Bar Graph
  This component could be made more customizable.
  It is a generic component, so test all uses when making changes.

  ## Example usage
  *IMPORTANT* - The parent wrapper needs a fixed height
  ```
  // Data will be display in the order its listed in the data array
  const data = [
    {
      label: 'Jan', // Label is the x-axis label
      'Water Usage': 44, // Water Usage will be used in the graph's legend
    },
    {
      label: 'Feb',
      'Water Usage': 48,
    },
    {
      label: 'Mar',
      'Water Usage': 36,
    },
  ];

  <Bar
    data={data}

    // This is a list of keys in each object which should be shown
    // (multiple keys causes a stacked bar)
    // The string is used in the graph legend
    keys={['Water Usage']}

    margin={{
      top: 0,
      right: 130,
      bottom: 50,
      left: 60,
    }}
  />
  ```
*/

export const Bar = (props) => {
  const {
    data = [],
    keys = ['Water Usage'],
    indexBy = 'label',
    enableLabel = true,
    axisLabels = {
      x: '',
      y: '',
    },
    margin = {
      top: 6,
      right: 120,
      bottom: 70,
      left: 0,
    },
  } = props;

  return (
    <ResponsiveBar
      colors={{ scheme: 'paired' }}
      theme={{
        fontSize: 8,
      }}
      data={data}
      keys={keys}
      indexBy={indexBy}
      margin={margin}
      padding={0.2}
      borderColor={{
        from: 'color',
        modifiers: [['darker', 1.6]],
      }}
      enableLabel={enableLabel}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 45,
        legend: axisLabels.x,
        legendPosition: 'middle',
        legendOffset: 32,
        fontSize: 6,
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legend: axisLabels.y,
        legendPosition: 'middle',
        legendOffset: -40,
      }}
      labelSkipWidth={12}
      labelSkipHeight={12}
      labelTextColor="#fff"
      legends={[
        {
          dataFrom: 'keys',
          anchor: 'bottom-right',
          direction: 'column',
          justify: false,
          translateX: 110,
          translateY: 0,
          itemsSpacing: 2,
          itemWidth: 100,
          itemHeight: 20,
          itemDirection: 'left-to-right',
          itemOpacity: 0.85,
          symbolSize: 16,
          effects: [
            {
              on: 'hover',
              style: {
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      renderTick={(val) => <div>{val}</div>}
      animate={false}
      motionStiffness={90}
      motionDamping={15}
    />
  );
};
